import { isArray } from "angular";
import { isDate, isObjectLike, values } from "lodash";

export const vsName = "recordsUtilsService";

const idSymbol = Symbol("recordId");

export class RecordsUtilsService {
  static $inject = [];

  private lastId: number = -1;

  constructor() {}

  stripIds(record: any) {
    if (isDate(record)) {
      return;
    }

    if (isArray(record)) {
      (<Array<unknown>>record).forEach((r) => this.stripIds(r));
      return;
    }

    if (isObjectLike(record)) {
      delete record.Id;
      record[idSymbol] = this.getNextId();
      Object.values(record).forEach((value) => this.stripIds(value));
    }
  }

  private getNextId(): number {
    const nextId = this.lastId--;
    if (this.lastId <= Number.MIN_SAFE_INTEGER) {
      this.lastId = -1;
    }
    return nextId;
  }

  getRecordId(record: any): number | undefined {
    return record.Id ?? record[idSymbol];
  }
}
